import TmrBaseResource from './TmrBaseResource'

export default class RepairReasons extends TmrBaseResource {
  static endpoint = '/repairReasons'
}
